module.exports = __webpack_public_path__ + "static/media/live-hero.cf536ee8.jpg";